import { defineStore } from 'pinia'

export type TNavigationTransitionDirection = 'forward' | 'back' | 'lateral'

// Read by App.vue (page slide) and CustomerNav.vue (bottom-nav layout morph)
// to animate consistently with the same navigation. Set from a router guard
// (router/index.ts) — see that guard for how direction is inferred.
export const useNavigationTransitionStore = defineStore('navigationTransition', {
  state: () => ({
    direction: 'lateral' as TNavigationTransitionDirection,
  }),

  actions: {
    setDirection(direction: TNavigationTransitionDirection): void {
      this.direction = direction
    },
  },
})
